/* ============================================================
   Mamacult — Brand JavaScript
   Scroll animations · Announcement bar · Sticky ATC
   ============================================================ */

(function () {
  'use strict';

  /* ---- Scroll Reveal ---- */
  function initReveal() {
    var selectors = '.mc-reveal, .mc-reveal--scale, .mc-reveal--left, .mc-reveal--right';
    var elements = document.querySelectorAll(selectors);
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) { el.classList.add('mc-revealed'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mc-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px 0px 0px' });

    elements.forEach(function (el) { observer.observe(el); });
  }

  /* ---- Announcement bar: pause on hover ---- */
  function initAnnouncement() {
    var slides = document.querySelector('.mc-announcement__slides');
    if (!slides) return;
    slides.addEventListener('mouseenter', function () { slides.style.animationPlayState = 'paused'; });
    slides.addEventListener('mouseleave', function () { slides.style.animationPlayState = 'running'; });
  }

  /* ---- Email capture: handle posted state ---- */
  function initCapture() {
    var success = document.querySelector('.mc-capture__success');
    if (!success) return;
    if (success.dataset.posted === 'true') {
      success.style.display = 'block';
      var form = document.getElementById('mc-capture-form');
      if (form) form.style.display = 'none';
      var divider = form && form.nextElementSibling;
      if (divider) divider.style.display = 'none';
    }
  }

  /* ---- Sticky Add-to-Cart on product page ---- */
  function initStickyATC() {
    var sticky = document.querySelector('.mc-sticky-atc');
    if (!sticky) return;
    var anchor = document.querySelector('.product-form__buttons, .product-form__submit, [data-mc-atc-anchor]');
    if (!anchor) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var hidden = entry.isIntersecting;
        sticky.classList.toggle('mc-sticky-atc--visible', !hidden);
        sticky.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      });
    }, { rootMargin: '-60px 0px 0px 0px' });

    io.observe(anchor);

    var scrollBtn = sticky.querySelector('[data-mc-sticky-scroll]');
    if (scrollBtn) {
      scrollBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.querySelector('.product-form__submit') || anchor;
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  /* ---- Pincode delivery check ---- */
  function initPincode() {
    var btn = document.querySelector('[data-mc-pincode-btn]');
    var input = document.querySelector('[data-mc-pincode-input]');
    var result = document.getElementById('mc-pincode-result');
    if (!btn || !input || !result) return;

    btn.addEventListener('click', function () {
      var pin = input.value.trim();
      if (!/^\d{6}$/.test(pin)) {
        result.textContent = 'Please enter a valid 6-digit pincode.';
        result.className = 'mc-pincode__result mc-pincode__result--na';
        return;
      }
      result.textContent = 'Checking...';
      result.className = 'mc-pincode__result mc-pincode__result--loading';

      /* Shiprocket / Delhivery API integration goes here.
         For now, a local check: metro pincodes get 2-day delivery. */
      setTimeout(function () {
        var metro = ['400001','110001','560001','600001','700001','500001','380001','411001','302001','226001'];
        var pinStr = String(parseInt(pin, 10));
        var isMetro = metro.some(function (m) { return pin.startsWith(m.slice(0,3)); });
        if (isMetro) {
          result.innerHTML = '<strong style="color:#3A8C5C">Delivery in 2–3 days</strong> — COD available';
        } else {
          result.innerHTML = '<strong style="color:#3A8C5C">Delivery in 4–6 days</strong> — COD available';
        }
        result.className = 'mc-pincode__result mc-pincode__result--ok';
      }, 600);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') btn.click();
    });
  }

  /* ---- Size Guide: modal open/close + cm/inch toggle ---- */
  function initSizeGuide() {
    /* Open triggers */
    document.querySelectorAll('[data-mc-sg-open]').forEach(function (btn) {
      if (btn.dataset.mcSgBound === 'true') return;
      btn.dataset.mcSgBound = 'true';
      btn.addEventListener('click', function () {
        var dlg = document.getElementById(btn.getAttribute('data-mc-sg-open'));
        if (!dlg) return;
        if (typeof dlg.showModal === 'function') {
          dlg.showModal();
        } else {
          dlg.setAttribute('open', '');
        }
      });
    });

    /* Dialogs: close button + backdrop click */
    document.querySelectorAll('[data-mc-sg-dialog]').forEach(function (dlg) {
      if (dlg.dataset.mcSgBound === 'true') return;
      dlg.dataset.mcSgBound = 'true';

      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) dlg.close();
      });

      dlg.querySelectorAll('[data-mc-sg-close]').forEach(function (closeBtn) {
        closeBtn.addEventListener('click', function () {
          if (typeof dlg.close === 'function') {
            dlg.close();
          } else {
            dlg.removeAttribute('open');
          }
        });
      });
    });

    /* Unit toggle (cm <-> inches), scoped per size-guide instance */
    document.querySelectorAll('[data-mc-sg]').forEach(function (root) {
      if (root.dataset.mcSgBound === 'true') return;
      root.dataset.mcSgBound = 'true';

      var buttons = root.querySelectorAll('[data-mc-sg-unit]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var unit = btn.getAttribute('data-mc-sg-unit');
          root.classList.toggle('mc-sg--in', unit === 'in');
          buttons.forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
        });
      });
    });
  }

  /* ---- Hero subtle entrance ---- */
  function initHero() {
    var hero = document.querySelector('.mc-hero');
    if (!hero) return;
    var img = hero.querySelector('.mc-hero__image');
    if (img && img.complete) {
      img.style.transform = 'scale(1.0)';
    } else if (img) {
      img.addEventListener('load', function () { img.style.transform = 'scale(1.0)'; }, { once: true });
    }
  }

  /* ---- Shopify Design Mode: re-run reveal on section load ---- */
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initAnnouncement();
    initSizeGuide();
  });

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initAnnouncement();
    initCapture();
    initStickyATC();
    initPincode();
    initHero();
    initSizeGuide();
  });
}());
